// Per-scene input lock. Modals/overlays increment it while open so movement
// controllers (WalkController) pause — the player can't walk Natalka around
// behind an open modal. Counter-based so nested modals (e.g. a confirm inside
// a context menu) balance correctly.

export function lockInput(scene) {
  scene._inputLocks = (scene._inputLocks || 0) + 1;
}

export function unlockInput(scene) {
  scene._inputLocks = Math.max(0, (scene._inputLocks || 0) - 1);
}

export function isInputLocked(scene) {
  return (scene._inputLocks || 0) > 0;
}

// A scene instance is reused by the next scene.start(): whatever modal was open when it was replaced
// (a DOM control such as the settings gear can open one while a scene change is under way) must not
// keep it locked forever. Called on every scene start (installInputLockReset).
export function resetInputLocks(scene) {
  scene._inputLocks = 0;
}

let lockResetInstalled = false;
export function installInputLockReset(Phaser) {
  if (lockResetInstalled) return;
  lockResetInstalled = true;
  const original = Phaser.Scenes.Systems.prototype.start;
  Phaser.Scenes.Systems.prototype.start = function (data) {
    if (this.scene) resetInputLocks(this.scene);
    return original.call(this, data);
  };
}
